import WorkspacesContainer from "./WorkspacesContainer";

export default WorkspacesContainer;
